// removed by extract-text-webpack-plugin
module.exports = {"body":"src-components-SimplePages-___index__body___39gY4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimplePages/index.css
// module id = 409
// module chunks = 3